"use client";

import React, { createContext, useContext, useState } from "react";

type ContactSupportData = {
  attachedFile?: File;
  message?: string;
  subject?: string;
};

type ContactSupportContextType = {
  data: ContactSupportData;
  setData: (data: ContactSupportData) => void;
  clearData: () => void;
};

const ContactSupportContext = createContext<
  ContactSupportContextType | undefined
>(undefined);

export const ContactSupportProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [contactSupportData, setContactSupportData] =
    useState<ContactSupportData>({});
  const setData = (data: ContactSupportData) => {
    setContactSupportData(data);
  };
  const clearData = () => {
    setContactSupportData({});
  };

  return (
    <ContactSupportContext.Provider
      value={{
        data: contactSupportData,
        setData,
        clearData,
      }}
    >
      {children}
    </ContactSupportContext.Provider>
  );
};

export const useContactSupportContext = () => {
  const context = useContext(ContactSupportContext);
  if (!context) {
    throw new Error("useFileContext must be used within a FileProvider");
  }
  return context;
};
